import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux'
import store from './store'
import { ThemeProvider } from '@material-ui/core/styles';
import theme from './colorTheme';

// import i18n
import './i18n';

const rootElement = document.getElementById('root')

ReactDOM.render(
  <Provider store={store()}>
    <ThemeProvider theme={theme}>
    <Suspense fallback="loading">
        <App />
    </Suspense>
    </ThemeProvider>
  </Provider>,
  rootElement
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
